// Author Lin
// Date 2021-10-05 13:16:22

import * as model from "@/model/mintalMes/prd/MintalMesPrdSmeltingElectrodeDischargeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdSmeltingElectrodeDischarge(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
